import { DeliveryMethod } from './mail-delivery-content'

export interface MailDeliveryHistory {
  id: string
  title: string
  content: string
  isNullSearchableChannelCode: boolean
  reservationApprovedStatuses: number[]
  channelCodes: { reservationChannelCodeId: string; name: string }[]
  isSendCompleted: boolean
  scheduledDeliveryAt: string
  totalSend: number
  totalOpen: number
  totalSuccess: number
  sentAt: string
  method: DeliveryMethod
}

export interface MailDeliveryHistoryResult {
  histories: MailDeliveryHistory[]
  hasMore: boolean
  total: number
}

export interface GetMailDeliveryHistoryParams {
  sentAtFrom?: string
  sentAtTo?: string
  page?: number
}

export interface DeliveryHistoryReservationItem {
  id: string // reservation.id
  reservationId: string
  guestName: string | null
  roomNumbers: string[] | null
  to: string
  isSucceeded: boolean
  isRejected: boolean
}

export interface MailDeliverySendResultsResult {
  succeededReservations: DeliveryHistoryReservationItem[]
  failedReservations: DeliveryHistoryReservationItem[]
}

export enum DeliveryResultTab {
  failed = 'failed',
  success = 'success',
}
